export enum NPCEncounterCinematicID {
  MysteriousStanger = "stranger",
  Otto = "otto",
  Thomas = "thomas",
  Culprit = "culprit",
  Mechanic = "mechanic",
}
